<template>
  <v-app class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nome"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :items="indexedItems"
          :item-class="getRowColor"
          :search="search"
          :single-expand="true"
          :expanded.sync="expanded"
          item-key="id"
          show-expand
          class="elevation-1"
        >
          <!-- <template #footer.prepend>
          <v-spacer />
        </template> -->
          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteSincronizadorC />
            </div>
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} pessoas</span
            >
          </template>

          <template v-slot:header.dt_ult_atendimento="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover
              title="Data do último atendimento realizado na APS ou MAC."
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:header.cnes_sort="{ header }">
            {{ nomeColunaCnes }}
            <span
              v-if="selectedEstabelecimento"
              v-b-tooltip.hover
              v-bind:title="selectedEstabelecimento.no_unidade_saude"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:item.dt_nascimento="{ item }">
            {{
              item.dt_nascimento != null ? formatDate(item.dt_nascimento) : ''
            }}
          </template>

          <template v-slot:item.dt_ult_atendimento="{ item }">
            {{
              item.dt_ult_atendimento != null
                ? formatDate(item.dt_ult_atendimento)
                : ''
            }}
          </template>

          <template v-slot:item.cnes_sort="{ item }">
            {{ item.cnes_sort }}
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td colspan="9">
              <table class="table table-interna">
                <thead>
                  <tr>
                    <th>CPF</th>
                    <th>CNS</th>
                    <th>Equipe</th>
                    <th>Microárea</th>
                    <th>Cadastrado por</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ item.nu_cpf }}</td>
                    <td>{{ item.nu_cns }}</td>
                    <td>{{ item.ine_fci }}</td>
                    <td>{{ item.micro_area }}</td>
                    <td>{{ item.no_profissional }}</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </template>
          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import utils from '@/mixins/utils.js'

export default {
  name: 'TabelaCadastros',
  components: {},
  props: {
    cadastros: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    selectedEstabelecimento: {
      type: Object,
      default: null,
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      expanded: [],
      enabled: null,
      search: '',
      headers: [
        {
          text: 'Nome',
          align: 'start',
          filterable: true,
          value: 'no_cidadao',
        },
        {
          text: 'Nascimento',
          align: 'start',
          filterable: false,
          value: 'dt_nascimento',
        },
        {
          text: 'Mãe',
          align: 'start',
          filterable: false,
          value: 'no_mae',
        },
        {
          text: 'Atendimento',
          align: 'start',
          filterable: false,
          value: 'dt_ult_atendimento',
          sortable: false,
          width: '150px',
        },
        {
          text: 'CNES',
          align: 'start',
          filterable: false,
          sortable: true,
          value: 'cnes_sort',
          width: '150px',
        },
        {
          text: 'Outros',
          align: 'start',
          filterable: false,
          value: 'qtd_atends_us_outras',
        },
        { text: '', value: 'data-table-expand' },
      ],
    }
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
  },
  computed: {
    indexedItems() {
      return this.cadastros.map((item, index) => {
        return {
          id: index,
          ...item,
          cnes_sort:
            item.color === 'red'
              ? Number(item.qtd_atends_us_selecionada_7dias || 0)
              : Number(item.qtd_atends_us_selecionada || 0),
        }
      })
    },
    nomeColunaCnes() {
      return (
        this.selectedEstabelecimento?.no_unidade_saude?.split(' ')[0] || 'CNES'
      )
    },
  },
  methods: {
    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Retorna a classe CSS da linha da tabela.
     *
     * @param {Object} item
     */
    getRowColor(item) {
      return `table-row-color-${item.color}`
    },
  },
}
</script>

<style></style>
